module.exports = __webpack_public_path__ + "static/headshot-nick-anderson.9a377716.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/headshot-nick-anderson.png
// module id = 137
// module chunks = 35783957827783 152909308826437